import {Component, ElementRef, EventEmitter, Inject, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {GeoLocationService} from "../services/geoLocation.service";
import {PointModel} from "../models/point.model";
import {TripModel} from "../models/trip.model";
import {AgmMap, GoogleMapsAPIWrapper, LatLngBoundsLiteral} from "@agm/core";
import "@google/maps";
import {GoogleMapsService} from "../services/googleMaps.service";
import {google} from "google-maps";
import GeocoderResult = google.maps.GeocoderResult;
import {HttpClient} from "@angular/common/http";
import {APP_BASE_HREF} from "@angular/common";
import {AppModeEnum} from "../enums/appMode.enum";
import {DiscoverTypeEnum} from "../enums/discoverType.enum";
import {ControlPosition, GoogleMap, LatLngBounds} from "@agm/core/services/google-maps-types";
import {addYourLocationButton} from "../utils/googleMapsLocationButton";
import {addCustomButtons} from "../utils/googleMapsButton";
import {Subject} from "rxjs/Subject";
import {AppConfig, AppConstants} from "../../constants";
import {AngularFireAuth} from "angularfire2/auth";
import {AngularFirestore} from "angularfire2/firestore";
import * as firebase from "firebase";
import {ActivatedRoute, Router} from "@angular/router";
import {QueryParams} from "../types/query-params.type";
import {FavouriteType} from "../types/favourite.type";
import {UserFavourites} from "../models/userFavourites.model";
import {CoordinatesModel} from "../models/coordinates.model";
import {ChooseTypeEnum} from "../enums/chooseType.enum";

@Component({
  selector: 'map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  providers: [GoogleMapsAPIWrapper]
})
export class MapComponent implements OnInit, OnChanges {

  @ViewChild('theMap') theMap: AgmMap;
  public googleNativeMap: GoogleMap;

  public sidebarOpen: boolean = false;

  public appModeEnum = AppModeEnum;
  public chooseTypeEnum = ChooseTypeEnum;
  public discoverTypeEnum = DiscoverTypeEnum;

  public appMode: AppModeEnum;
  public chooseType: ChooseTypeEnum;
  public discoverType: DiscoverTypeEnum;

  public user: any;
  public userFavourites: UserFavourites;
  public userPlannedTrips: string[];

  public mapPoints: PointModel[] = [];

  public trips: TripModel[] = [];
  public selectedTrip: TripModel;
  public selectedTripIndex: number;
  public tripDirection: TripModel;
  public tripPointsDirection: any;

  public countries;
  public currentCountryPolygon: any;
  public currentCountryPolygonPath: any;

  public currentLocation: GeocoderResult[];
  public currentCountry: string;
  public countryBounds;
  public currentCoordinates: CoordinatesModel = {
    lat: 47.024629,
    lng: 28.832407
  };


  public radiusKm: number;

  get radiusM(): number {
    return this.radiusKm * 1000 || 0;
  }

  public approximationKm: number;

  get approximationM(): number {
    return this.approximationKm * 1000 || 0;
  }

  public numberOfPoints: number;

  public suggestionIndex: number;
  public suggestion: PointModel;
  public destination: PointModel;
  public directionDetails: any;
  public directionWaypoints: any;
  public mapReady: boolean = false;
  private projection;

  private queryParams: any;
  private preSelectCoordinates: string;
  private preSelectPoi: string;
  private preSelectTrip: string;
  // private preSelectFavourite: string;
  private drawDirectionToPreSelectedItem: boolean;


  constructor(
    @Inject(APP_BASE_HREF) private baseHref: string,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    public geoLocationService: GeoLocationService,
    public googleMapsService: GoogleMapsService,
    private gmapsApi: GoogleMapsAPIWrapper,
    private db: AngularFirestore,
    private afAuth: AngularFireAuth
  ) {
    this.route.queryParams.subscribe(params => {
      this.readFromQueryParams(params);
    });

    if (!AppConfig.onlyMoldova) {
      this.http.get(this.baseHref + 'assets/data/countries.json').subscribe((res) => {
        this.countries = res;
      });
    }
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('RandomRideUserInfo'));
    this.loadUserFavourites();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  public toggleSidebar(state?: boolean){
    this.sidebarOpen = typeof state === 'undefined' ? !this.sidebarOpen : state;
    this.theMap.triggerResize(true);
  }

  public readFromQueryParams(params: QueryParams){
    this.appMode = params.mode ? AppModeEnum[params.mode as string] :  AppConfig.defaultParams.mode;
    this.chooseType = params.choose ? ChooseTypeEnum[params.choose as string] :  AppConfig.defaultParams.choose;
    this.discoverType = params.discover ? DiscoverTypeEnum[params.discover as string] :  AppConfig.defaultParams.discover;
    this.radiusKm = params.radius ? +params.radius : AppConfig.defaultParams.radius;
    this.approximationKm = params.approximation ? +params.approximation : AppConfig.defaultParams.approximation;
    this.numberOfPoints = params.quantity ? +params.quantity : AppConfig.defaultParams.quantity;
    this.currentCountry = params.country ? params.country : AppConfig.defaultParams.country;
    this.directionWaypoints = params.waypoints ? params.waypoints : null;
    this.preSelectPoi = params.poi ? params.poi : null;
    this.preSelectTrip = params.trip ? params.trip : null;
    this.preSelectCoordinates = params.location ? params.location : null;
    // this.preSelectFavourite = params.favourite ? params.favourite : null;
    // this.drawDirectionToPreSelectedItem = params.drawDirection ? (params.drawDirection == 'true') : null;

    // if (params.location){
    //   let location = params.location.replace('@', '').split(',');
    //   this.preSelectCoordinates = {lat: +location[0], lng: +location[1], type: ['custom']};
    // } else {
    //   // this.suggestion = null;
    // }
  }

  public setQueryParams(){
    let queryParams: QueryParams = {
      mode: AppModeEnum[this.appMode],
    };

    switch (this.appMode) {
      case this.appModeEnum.choose:
        queryParams.choose = ChooseTypeEnum[this.chooseType];
        switch (this.chooseType) {
          case this.chooseTypeEnum.poi:
            this.suggestion ? queryParams.poi = this.suggestion.uid : this.preSelectPoi ? queryParams.poi = this.preSelectPoi : '';
            break;
          case this.chooseTypeEnum.trip:
            this.selectedTrip ? queryParams.trip = this.selectedTrip.uid : this.preSelectTrip ? queryParams.trip = this.preSelectTrip : '';
            break;
        }
        break;
      case this.appModeEnum.discover:
        queryParams.discover = DiscoverTypeEnum[this.discoverType];
        switch (this.discoverType) {
          case this.discoverTypeEnum.country:
            queryParams.country = this.currentCountry;
            break;
          case this.discoverTypeEnum.circle:
            queryParams.radius = this.radiusKm;
            queryParams.approximation = this.approximationKm;
            break;
        }
        queryParams.quantity = this.numberOfPoints;
        this.suggestion ? queryParams.location = `@${this.suggestion.lat},${this.suggestion.lng}` : '';
        break;
      case this.appModeEnum.join:
        this.suggestion ? queryParams.poi = this.suggestion.uid : '';
        break;
      case this.appModeEnum.favourites:
        // this.suggestion ? queryParams.favourite = this.suggestion.uid : '';
        // this.suggestion ? queryParams.favourite = this.suggestion.uid : this.preSelectFavourite ? queryParams.favourite = this.preSelectFavourite : '';

        break;
    }

    // if (this.destination){
    //   queryParams.drawDirection = 'true';
    // }

    this.router.navigate(["."], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: true,
    });
  }

  public markMapAsReady(map) {
    this.mapReady = true;
    this.googleNativeMap = map;
    addYourLocationButton(map, this.geoLocationService.getLocation(), this.updateCurrentPosition.bind(this));
    this.updateCurrentPosition();
    this.appModeChanged();
    /*
    let buttons = [
      {
        icon: null,
        title: '<',
        clickCb: this.nextDirection.bind(this)
      },
      {
        icon: null,
        title: 'Random',
        clickCb: this.randomDirection.bind(this)
      },
      {
        icon: null,
        title: '>',
        clickCb: this.prevDirection.bind(this)
      },
    ];
    addCustomButtons(
      map,
      ControlPosition[ControlPosition.BOTTOM_CENTER],
      'horizontal',
      buttons
    );
    addCustomButtons(
      map,
      ControlPosition[ControlPosition.LEFT_BOTTOM],
      'vertical',
      buttons
    );
    */
  }

  public updateCurrentPosition(pos?) {

    if (AppConfig.onlyMoldova) {
      this.currentCountry = 'MD';
      this.currentCountryPolygonPath = google.maps.geometry.encoding.decodePath(AppConstants.encodedCountryBorderPolygons.MD);
    }

    const onPositionChange = ((pos) => {
      this.currentCoordinates = pos;
      this.db.collection('users/' + this.user.fbId + '/locations').add({
        location: new firebase.firestore.GeoPoint(pos.lat, pos.lng),
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        accuracy: pos.accuracy,
      });
      this.addDistanceToPoints();
      if (!AppConfig.onlyMoldova) {
        this.googleMapsService.reverseGeocoding(this.currentCoordinates.lat + ',' + this.currentCoordinates.lng)
          .then((res: GeocoderResult[]) => {
            this.currentLocation = res;
            let filtered_address = res.length && res[0].address_components.filter((address_component) => {
              return address_component.types.includes("country");
            });
            this.currentCountry = filtered_address.length ? filtered_address[0].short_name : null;
            let encodedCountry = this.countries[this.currentCountry].encodedPolygon;
            this.currentCountryPolygonPath = google.maps.geometry.encoding.decodePath(encodedCountry);
            // console.log(this.currentLocation, this.currentCountryPolygon);
          });
      }
    });

    if (pos) {
      onPositionChange(pos);
    } else {
      this.geoLocationService.getLocation().subscribe(pos => {
        onPositionChange(pos);
        if (this.mapReady) {
          let latlng = new google.maps.LatLng(pos.lat, pos.lng);
          this.googleNativeMap.setCenter(latlng as any);
        }
      });
    }
  }


  public generateRandomPoints(randomType) {
    switch (randomType.toLowerCase()) {
      case "circle":
        this.mapPoints = this.generateMapPoints(this.currentCoordinates, this.radiusKm, this.numberOfPoints);
        break;
      case "country":
        this.mapPoints = this.randomGeoInCountry(this.numberOfPoints);
        break;
    }
    if(this.preSelectCoordinates){
      let coordinates = this.preSelectCoordinates.replace('@', '').split(',');
      let location = {
        lat: +coordinates[0],
        lng: +coordinates[1],
        type: ['custom']
      };
      this.mapPoints[0] = location;
      this.addDistanceToPoints();
      this.setSuggestion(location, 0);
      if(this.drawDirectionToPreSelectedItem) {
        setTimeout(()=>this.drawDirection(), 100);
      }
    } else {
      this.addDistanceToPoints();
      this.setSuggestion();
    }
    this.zoomToBounds(false);
    // this.theMap.triggerResize(true);
  }

  public zoomToBounds(boundsToPoints = false){
    if (boundsToPoints){
     let bounds = new google.maps.LatLngBounds();
      let selected = this.suggestion || this.selectedTrip || new PointModel();
      bounds.extend(this.currentCoordinates);
      if(selected.lat && selected.lng){
        bounds.extend(selected);
      }
      if(selected && selected.children){
        selected.children.forEach(item => {
          if (item.lat && item.lng) {
            bounds.extend(item);
          }
        });
      }
      this.googleNativeMap.fitBounds(bounds as any);
    } else {
      if (!this.countryBounds) {
        this.generateCountryBounds();
      }
      if (this.countryBounds && this.googleNativeMap) {
        if (this.discoverType !== this.discoverTypeEnum.circle) {
          this.googleNativeMap.fitBounds(this.countryBounds);
          // this.googleNativeMap.setZoom(10);
        } else {
          let circle = new google.maps.Circle({
            center: this.currentCoordinates,
            radius: this.radiusM + this.approximationM,
          });
          this.googleNativeMap.fitBounds(circle.getBounds() as any);
        }
      }
    }
  }

  public setSuggestion(point?, index?) {
    this.suggestion = point;
    this.suggestionIndex = index;
    this.zoomToBounds(true);
    this.setQueryParams();
  }

  public drawDirection(point?) {
    if (point) {
      this.setSuggestion(point);
    }
    this.destination = this.suggestion;
    this.setQueryParams();
  }

  public clearDestination() {
    this.destination = undefined;
    this.tripDirection = undefined;
    this.tripPointsDirection = undefined;
  }

  public prevDirection() {
    typeof this.suggestionIndex === 'number' ?
      this.suggestionIndex - 1 < 0 ?
        this.setSuggestion(this.mapPoints[this.mapPoints.length - 1], this.mapPoints.length - 1) :
        this.setSuggestion(this.mapPoints[this.suggestionIndex - 1], this.suggestionIndex - 1) :
      this.setSuggestion(this.mapPoints[0], 0);
  }

  public nextDirection() {
    typeof this.suggestionIndex === 'number' ?
      this.suggestionIndex + 1 < this.mapPoints.length ?
        this.setSuggestion(this.mapPoints[this.suggestionIndex + 1], this.suggestionIndex + 1) :
        this.setSuggestion(this.mapPoints[0], 0) :
      this.setSuggestion(this.mapPoints[0], 0);
  }

  public randomDirection() {
    let randomIndex = Math.floor(Math.random() * this.mapPoints.length);
    this.setSuggestion(this.mapPoints[randomIndex], randomIndex);
  }

  public openNavigation() {
    let origin, destination, waypoints;
    if(this.appMode === AppModeEnum.join){
      origin = `&origin=${this.selectedTrip.lat},${this.selectedTrip.lng}`;
      let lastChild = this.selectedTrip.children.slice(-1).pop();
      destination = `&destination=${lastChild.lat},${lastChild.lng}`;
      let legs = this.selectedTrip.children.slice(0, -1);
      waypoints = legs.length ? `&waypoints=${legs.map(i => `${i.lat},${i.lng}`).join('|')}` : '';
    } else {
      origin = `&origin=${this.currentCoordinates.lat},${this.currentCoordinates.lng}`;
      destination = `&destination=${this.destination.lat},${this.destination.lng}`;
      waypoints = this.directionWaypoints && this.directionWaypoints.length ? `&waypoints=${this.directionWaypoints.slice().map(i => `${i.lat()},${i.lng()}`).join('|')}` : '';
    }
    window.open(`https://www.google.com/maps/dir/?api=1${origin}${destination}${waypoints}&travelmode=driving&dir_action=navigate`, "_blank");
  }

  public randomGeoInCircle(center, radius, approximation = this.approximationKm, angle?) {
    angle = angle || Math.random() * Math.PI * 2 * 100;
    let rdMax = (radius + approximation);
    let rdMin = (radius - approximation);
    let rd = Math.floor(Math.random() * (rdMax - rdMin)) + rdMin;
    let originalPoint = new google.maps.LatLng(center.lat, center.lng);
    let generatedPoint = google.maps.geometry.spherical.computeOffset(originalPoint, rd * 1000, angle);
    let res = {
      'lat': +generatedPoint.lat().toFixed(5),
      'lng': +generatedPoint.lng().toFixed(5),
      'distance': rd || +(google.maps.geometry.spherical.computeDistanceBetween(originalPoint, generatedPoint) / 1000).toFixed(5),
      'angle': angle.toFixed(5),
      'type': ["random", "inCircle"],
    };
    return res;
  }

  public randomGeoInCountry(amount = this.numberOfPoints) {
    let mapPoints = [];
    // this.currentCountryPolygon = new google.maps.Polygon({
    //   paths: this.currentCountryPolygonPath
    // });
    // let bounds = new google.maps.LatLngBounds();
    // for (let i=0; i < this.currentCountryPolygon.getPath().getLength(); i++) {
    //   bounds.extend(this.currentCountryPolygon.getPath().getAt(i));
    // }
    this.generateCountryBounds();
    if (!this.countryBounds) return;
    let sw = this.countryBounds.getSouthWest();
    let ne = this.countryBounds.getNorthEast();
    while (mapPoints.length < amount) {
      let ptLat = Math.random() * (ne.lat() - sw.lat()) + sw.lat();
      let ptLng = Math.random() * (ne.lng() - sw.lng()) + sw.lng();
      let point = new google.maps.LatLng(ptLat, ptLng);
      if (google.maps.geometry.poly.containsLocation(point, this.currentCountryPolygon)) {
        let currentPoint = new google.maps.LatLng(+this.currentCoordinates.lat, +this.currentCoordinates.lng);
        let res = {
          'lat': +point.lat().toFixed(5),
          'lng': +point.lng().toFixed(5),
          'distance': +(google.maps.geometry.spherical.computeDistanceBetween(currentPoint, point) / 1000).toFixed(5),
          'type': ["random", "inCountry"],
        };
        mapPoints.push(res);
      }
    }

    return mapPoints;
  }


  public generateCountryBounds() {
    if (!google.maps.Polygon || !this.currentCountryPolygonPath) return;
    this.currentCountryPolygon = new google.maps.Polygon({
      paths: this.currentCountryPolygonPath
    });
    this.countryBounds = new google.maps.LatLngBounds();
    for (let i = 0; i < this.currentCountryPolygon.getPath().getLength(); i++) {
      this.countryBounds.extend(this.currentCountryPolygon.getPath().getAt(i));
    }
  }

//Generate a number of mappoints
  public generateMapPoints(centerpoint, distance, amount) {
    let mapPoints = [];
    for (let i = 0; i < amount; i++) {
      mapPoints.push(this.randomGeoInCircle(centerpoint, distance));
    }
    return mapPoints;
  }

  public pinColor(pin) {
    let color;
    if (!this.currentLocation || !pin || !pin.location || !pin.location[pin.location.length - 1]) {
      color = 'grey';
    } else {
      if (this.currentLocation[this.currentLocation.length - 1].formatted_address === pin.location[pin.location.length - 1].formatted_address) {
        color = 'green';
      } else {
        color = 'red';
      }
    }
    return color;
  }

  public async getPoi() {

    this.db.collection<PointModel>('poi').snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return {id, ...data};
      });
    }).subscribe(async (res) => {
      await Promise.all( res.map( async (parentItem) => {
        return new Promise(resolve => {
          this.db
            .collection('poi')
            .doc(parentItem.id)
            .collection('children')
            .valueChanges()
            .subscribe(children => {
              parentItem.children = children;
              return resolve();
            });
        });
      }));
      this.mapPoints = res;
      this.addDistanceToPoints();

      if(this.preSelectPoi){
        let poi;
        this.mapPoints.some(point => {
          if( point.uid === this.preSelectPoi ){
            poi = point;
            return true;
          } else {
            return point.children.some(child => {
              if ( child.uid === this.preSelectPoi ){
                poi = child;
                return true;
              } else {
                return false;
              }
            })
          }
        });
        setTimeout( () => {
          this.setSuggestion(poi ? poi : null);
          if(this.drawDirectionToPreSelectedItem && poi){
            this.drawDirection();
          }
        }, 100);

      }
    });
  }

  public async loadUserFavourites(){
    return new Promise( resolveMain => {
      this.db.collection('users/'+this.user.fbId+'/favourites').valueChanges().subscribe(async (res: FavouriteType[]) => {
        this.userFavourites = {
          choose: [],
          discover: [],
          join: []
        };
        await Promise.all( res.map( async (fav) => {
          return new Promise(resolve => {
            this.userFavourites[fav.favouriteType].push(fav);
            return resolve();
          });
        }));
        // console.log('list of user favourites was updated', this.userFavourites);
        if (this.appMode === AppModeEnum.favourites) {
          this.getFavourites();
        }
        return resolveMain();
      });
    });
  }

  public async getFavourites() {
    let favItems = [];

    if (!this.userFavourites) return;

    await Promise.all( this.userFavourites.choose.map( async (favPoi) => {
      return new Promise(resolve => {
        let collection;
        if(favPoi.parentUid){
          collection = this.db
            .collection('poi')
            .doc(favPoi.parentUid)
            .collection('children')
            .doc(favPoi.uid)
        } else {
          collection = this.db
            .collection('poi')
            .doc(favPoi.uid)
        }
        collection
          .valueChanges()
          .subscribe(poi => {
            favItems.push(poi);
            return resolve();
          });
      });
    }));

    await Promise.all( this.userFavourites.discover.map( async (favPoint) => {
      return new Promise(resolve => {
        favItems.push(favPoint);
        return resolve();
      });
    }));
    this.mapPoints = favItems;
    this.addDistanceToPoints();
  }

  public async getTrips() {


    this.http.get(this.baseHref + 'assets/data/trips.json').subscribe((res: TripModel[]) => {
      this.trips = res;

      if(this.preSelectTrip){
        let selectedTrip;
        this.trips.some(trip => {
          if( trip.uid === this.preSelectTrip ){
            selectedTrip = trip;
            return true;
          } else {
            return trip.children.some(child => {
              if ( child.uid === this.preSelectTrip ){
                selectedTrip = child;
                return true;
              } else {
                return false;
              }
            })
          }
        });
        setTimeout( () => {
          this.setSelectedTrip(selectedTrip ? selectedTrip : null);
          if(this.drawDirectionToPreSelectedItem && selectedTrip){
            this.drawDirection();
          }
        }, 100);
      }

    });



    // this.db
    //   .collection<EventModel>('events')
    //   .valueChanges()
    //   .subscribe(events => {
    //     this.events = events;
    //   });

  }

  public appModeChanged() {
    if (!this.mapReady && !google) return;
    this.mapPoints = [];
    switch (this.appMode) {
      case this.appModeEnum.choose:
        this.clearSelectedTrip();
        switch (this.chooseType) {
          case this.chooseTypeEnum.poi:
            this.getPoi();
            break;
          case this.chooseTypeEnum.trip:
            this.getTrips();
            break;
        }
        break;
      case this.appModeEnum.discover:
        this.clearSelectedTrip();
        switch (this.discoverType) {
          case this.discoverTypeEnum.country:
            this.generateRandomPoints('country');
            break;
          case this.discoverTypeEnum.circle:
            this.generateRandomPoints('circle');
            break;
        }
        break;
      case this.appModeEnum.favourites:
        this.clearSelectedTrip();
        this.getFavourites();
        break;
      case this.appModeEnum.join:
        this.clearDestination();
        break;
    }
    this.setQueryParams();
  }

  public updatePointPosition(point, $event) {
    console.log(point, $event);
    point.lat = $event.coords.lat.toFixed(5);
    point.lng = $event.coords.lng.toFixed(5);
  }


  public addDistanceToPoints() {
    this.mapPoints.forEach(point => {
      point.distance = this.googleMapsService.computeDistance(this.currentCoordinates, point, 0);
      if (point.children) {
        point.children.forEach(child => {
          child.distance = this.googleMapsService.computeDistance(this.currentCoordinates, child, 0);
        });
      }
    });
    // console.log('this.mapPoints after distance calculation:', this.mapPoints);
  }

  public isFavourite(point){
    if (!this.userFavourites) return false;

    if(this.appMode === AppModeEnum.favourites){
      return true;
    }
    if(this.appMode === AppModeEnum.discover){
      return this.userFavourites[AppModeEnum[this.appMode]].some(item => {
        return item.lat === point.lat && item.lng === point.lng;
      });
    }
    if(this.appMode === AppModeEnum.choose) {
      return this.userFavourites[AppModeEnum[this.appMode]].some(item => {
        return item.uid === point.uid;
      });
    }
    return false;
  }

  public havePlansToJoin(trip){
    if (!this.userPlannedTrips) return false;

    if(this.appMode === AppModeEnum.join){
      return true;
    }
    return false;
  }

  /*
  public getDistanceToCountryBorder(from, to){
    let intersetionPoly = this.getIntesection([from,to]);
    let distance = 0;
    for (let i = 1; i < intersetionPoly.length; i++){
      let first = new google.maps.LatLng(intersetionPoly[i-1].lat, intersetionPoly[i-1].lng);
      let second = new google.maps.LatLng(intersetionPoly[i].lat, intersetionPoly[i].lng);
      let currentDistance = google.maps.geometry.spherical.computeDistanceBetween(first, second);
      if (currentDistance > distance){
        distance = currentDistance;
      }
    }
    return distance / 1000;
  }

  public getIntesection(vector){
    let countryPolygon = new google.maps.Polygon({
      paths: this.currentCountryPolygon
    });
    let newVector = JSON.parse(JSON.stringify(vector));
    let lastPoint = JSON.parse(JSON.stringify(newVector[0]));
    lastPoint.lat += 0.000001;
    newVector.push(lastPoint);
    newVector = newVector.map(i => new google.maps.LatLng(i.lat, i.lng));
    let vectorPolygon = new google.maps.Polygon({
      paths: newVector
    });
    let jstsCountryPolygon = this.createJstsPolygon(countryPolygon);
    let jstsVectorPolygon = this.createJstsPolygon(vectorPolygon);
    let intersection = jstsCountryPolygon.intersection(jstsVectorPolygon);

    let intersectionCoords = intersection.getCoordinates().map(function (coord) {
      return { lat: coord.x, lng: coord.y };
    });

    console.log('intersectionCoords', intersectionCoords);
    return intersectionCoords;
  }

  private createJstsPolygon(polygon) {
    let path = polygon.getPath();
    let coordinates = path.getArray().map(function name(coord) {
      return new jsts.geom.Coordinate(coord.lat(), coord.lng());
    });
    coordinates.push(coordinates[0]);
    let shell = this.geometryFactory.createLinearRing(coordinates);
    return this.geometryFactory.createPolygon(shell);
  }
  */


  /*
 *
 *  Events Methods
 *
 */

  public setSelectedTrip(trip?, index?) {
    this.selectedTrip = trip;
    this.selectedTripIndex = index;
    this.zoomToBounds(true);
    this.setQueryParams();
  }
  public setSelectedTripPoint(trip?, point?, index?) {
    this.selectedTrip = trip;
    this.selectedTripIndex = index;
    this.zoomToBounds(true);
    this.setQueryParams();
  }

  public prevTrip() {
    typeof this.selectedTripIndex === 'number' ?
      this.selectedTripIndex - 1 < 0 ?
        this.setSelectedTrip(this.trips[this.trips.length - 1], this.trips.length - 1) :
        this.setSelectedTrip(this.trips[this.selectedTripIndex - 1], this.selectedTripIndex - 1) :
      this.setSelectedTrip(this.trips[0], 0);
  }

  public nextTrip() {
    typeof this.selectedTripIndex === 'number' ?
      this.selectedTripIndex + 1 < this.trips.length ?
        this.setSelectedTrip(this.trips[this.selectedTripIndex + 1], this.selectedTripIndex + 1) :
        this.setSelectedTrip(this.trips[0], 0) :
      this.setSelectedTrip(this.trips[0], 0);
  }

  public randomTrip() {
    let randomIndex = Math.floor(Math.random() * this.trips.length);
    this.setSelectedTrip(this.trips[randomIndex], randomIndex);
  }

  public clearSelectedTrip(){
    this.selectedTrip = undefined;
  }


  get selectedTripStart(){
    if (this.tripDirection && this.tripDirection.children && this.tripDirection.children.length){
      return this.tripDirection.children[0];
    } else if (this.tripPointsDirection){
      return this.tripPointsDirection.origin;
    }
  }
  get selectedTripFinish(){
    if (this.tripDirection && this.tripDirection.children && this.tripDirection.children.length){
      return this.tripDirection.children.slice(-1).pop();
    } else if (this.tripPointsDirection){
      return this.tripPointsDirection.destination;
    }
  }
  get selectedTripLegs(){
    if (this.tripDirection && this.tripDirection.children && this.tripDirection.children.length){
      return this.tripDirection.children.slice(1, -1);
    } else if (this.tripPointsDirection){
      return null;
    }
  }

  public drawTripDirection(trip){
    this.tripPointsDirection = null;
    this.tripDirection = trip;
  }
  public drawTripPointsDirection(trip){
    this.tripDirection = null;
    this.tripPointsDirection = trip;
  }

  public joinTrip(){

  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/map/map.component.ts